// things that dont work:
// X: click on cover in project overlay. had to disable it, otherwise we cant scroll :D
// X: fullscreen slider active in project overlay, and in project page. doesnt work :D
// X: link to a project overlay, link contains an anchorlink - this will not work cause when i add a # to the url, the data- attributes get removed

// todos:
// parallax √
// showhide st,nav √
// imagehover √
// lightbox √
// animate in on scroll √
// fullscreen slider √
// need to set overlay page on popstate too! in case: we are on overlay page, we click on a project, we click back, we reload, we click forward! √
// when navigating from one project to another, make transition out work √
// edge case: were on overview page. click on project. click back. click forward. scroll down. if we click back now, the overlays' scroll position switches √
// when i go to this page: http://localhost:10020/empty-project2123123/ from the overlay (name: empty project 2) then the overlay doesnt work and going back also doesnt work √
// test if it works if we're coming from a category page √ or news page √
// custom close icon setting √
// when a page overlay link is inside a project overlay √
// add a class when animation in has finished (for styling site title for example to a different color) √
// disable automatically when woocommerce is active √
// disable when ajax mode is active √
// set body classes for type-* id-* catid-* etc on overlay open and close √
// test html5 lazyloading √
// test custom phone layouts √
// covers √
// test footers √
// do page overlays get loaded twice?, no √
// anchorlinks: project link with anchor that opens project overlay √
// sticky elements √
// horizontal grid √
// layers √
// placed freely elements √
// splitscreen √ - just wont work for inside a project overlay, but thats ok
// carousel √
// test if element_animate_in_on_scroll.js still work in page overlays √
// expand, collapse rows √
// showhide js for options √
// fullscreen slider: there seems to be a general issue with this page: http://localhost:10020/same-height-images/ probably unrelated to this module √
// test different browsers: firefox √,
// fullscreen slider: test if it still works without projects_overlays module, because of change in fullpage.js, line 1495 √
// webgl slider has too low resolution √ seems like its fine √
// test: Show arrows in projects for navigation (Project Arrows) √
// test activate menupoint √
// when going from an open overlay project to a different page than the one thats in the background, only close the overlay, once the background page was loaded when animation is not none √
// test esc key, only let esc key be hittable once, until overlay is closed √
// transition when navigating: none: this insert hidewrap css now i think! fixed! √
// test passworded project page √

// test again if CPL works
// see if this setting can make sense: once the animation starts, have a grey transparent overlay over the overview page
// test on mobile device
// test on tablet
// disable for phone setting
// disable for tablet setting

// setting for overlay page, and show it, when we hard-reload on a project, or just maybe show the frontpage as overlay on hard reload

import history_controller from '../history/history_controller_new'
import { utility_controller } from '../utility/utility_controller'

var shouldOpenOverlay = false
var shouldCloseOverlay = false

var historyStateOfOverviewPageWeCameFrom = null
// Parallel to `previousStateObj`. The raw history.state doesn't include the
// page's URL, so on a back/forward `pop` to a project we'd otherwise lose
// the overview URL we want to return to. Tracked here, updated wherever
// `previousStateObj` is updated.
var previousHref = typeof window !== 'undefined' ? window.location.href : ''
var previousStateObj = null
// Direct-load mode: when the underlay can't be safely lazy-loaded (because
// it or its assigned footer contains a shortcode), the close button must
// hard-navigate to the underlay URL instead of trying the SPA reveal —
// shortcodes that depend on `DOMContentLoaded` having NOT fired yet break
// when injected via AJAX. This URL gets read by goBackToLastOverview()
// and short-circuits to window.location.href = it.
var directLoadHardNavCloseUrl = null

var getProjectsOverlayEasing = function (easing) {
	if (typeof easing !== 'string' || easing === '') {
		return 'cubicBezier(0.075, 0.82, 0.165, 1)'
	}
	var cssKeywordMap = {
		ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
		'ease-in': 'cubicBezier(0.42, 0, 1, 1)',
		'ease-out': 'cubicBezier(0, 0, 0.58, 1)',
		'ease-in-out': 'cubicBezier(0.42, 0, 0.58, 1)',
	}
	if (cssKeywordMap[easing]) {
		return cssKeywordMap[easing]
	}
	return easing.replace('cubic-bezier', 'cubicBezier')
}
var cubicBezier = getProjectsOverlayEasing(layData.po_easing_function)
var duration = parseInt(layData.po_animation_duration, 0)

var setFirstState = function () {
	// Get state from history location (modern history package handles Safari/mobile quirks)
	previousStateObj = window.layHistory ? window.layHistory.location.state : window.history.state
}

var setShouldOpenAndShouldCloseOnPush = function (stateObj) {
	shouldOpenOverlay = false
	shouldCloseOverlay = false

	if (previousStateObj == null || !window.utility_controller.isProjectsOverlayEnabled()) {
		return false
	}

	if (previousStateObj.type != 'project' && stateObj.type == 'project') {
		shouldOpenOverlay = true
		shouldCloseOverlay = false

		historyStateOfOverviewPageWeCameFrom = Object.assign({ title: document.title, href: window.location.href }, previousStateObj)
	} else if (previousStateObj.type == 'project' && stateObj.type != 'project' && historyStateOfOverviewPageWeCameFrom != null) {
		shouldCloseOverlay = true
		shouldOpenOverlay = false
	}

	previousStateObj = stateObj
	previousHref = typeof window !== 'undefined' ? window.location.href : previousHref

	if (shouldOpenOverlay) {
	}
	if (shouldCloseOverlay) {
	}

	if (!window.utility_controller.isProjectsOverlayEnabled()) {
		shouldOpenOverlay = false
		shouldCloseOverlay = false
	}
}

var setShouldOpenAndShouldCloseOnPop = function (stateObj) {
	shouldOpenOverlay = false
	shouldCloseOverlay = false

	if (previousStateObj == null || layData.projects_overlays != 'on') {
		return false
	}

	// Safari fix: Add null check for stateObj to prevent crashes
	if (stateObj == null) {
		return false
	}

	if (previousStateObj.type != 'project' && stateObj.type == 'project') {
		shouldOpenOverlay = true
		shouldCloseOverlay = false
		// Wrap with `title` + `href` from the *previous* page (the overview
		// we just popped away from) — `previousStateObj` alone is the raw
		// history.state which doesn't carry an href, and using
		// `window.location.href` here would be wrong because by the time
		// popstate fires the URL has already changed to the project page.
		// `previousHref` was captured at the previous state transition.
		historyStateOfOverviewPageWeCameFrom = Object.assign(
			{ title: document.title, href: previousHref },
			previousStateObj,
		)
	} else if (previousStateObj.type == 'project' && stateObj.type != 'project') {
		shouldCloseOverlay = true
		shouldOpenOverlay = false
		if (historyStateOfOverviewPageWeCameFrom == null) {
			// in case the historyStateOfOverviewPageWeCameFrom doesnt exist, because there was no pushstate before, we need to set it here.
			// this happens for example when: we are on overlay page, we click on a project, we click back, we reload, we click forward
			historyStateOfOverviewPageWeCameFrom = Object.assign({ title: document.title, href: window.location.href }, stateObj)
		}
	}

	previousStateObj = stateObj
	previousHref = typeof window !== 'undefined' ? window.location.href : previousHref

	if (shouldOpenOverlay) {
	}
	if (shouldCloseOverlay) {
	}

	if (!window.utility_controller.isProjectsOverlayEnabled()) {
		shouldOpenOverlay = false
		shouldCloseOverlay = false
	}
}

// i used to call this "isOverlayOpen", but in reality, it just determines whether its display is block or not
// because if its fully open is determined if the opening animation has finished
var isOverlayDisplayBlock = function () {
	if (!window.utility_controller.isProjectsOverlayEnabled()) {
		return false
	}
	if (jQuery('html').hasClass('show-project-overlay')) {
		return true
	}
	return false
}

var bindBackgroundClick = function () {
	// this was requested by a user, they use some custom css to have the project overlay just fill half the screen
	// and they want to be able to click on the background to close the overlay
	// so we bind a click event to the background
	jQuery(document).on('click', '#lay-project-overlay-background', function () {
		if (isOverlayDisplayBlock() && isAnimatingOut == false && isAnimatingIn == false) {
			goBackToLastOverview()
		}
	})
}

var bindEscapeKey = function () {
	// just go to previous page to hide overlay
	document.body.addEventListener('keydown', function (e) {
		if (e.key == 'Escape') {
			if (isOverlayDisplayBlock() && isAnimatingOut == false && isAnimatingIn == false && !jQuery('body').hasClass('lightbox-open') && !jQuery('body').hasClass('lay-overlay-open') && !jQuery('body').hasClass('search-open')) {
				goBackToLastOverview()
			}
		}
	})
}

var goBackToLastOverview = function () {
	removeCloseIcon()
	// since we cant go back in history, because its hard to determine the n of history.go(-n)
	// Direct-load close path: when the underlay couldn't be lazy-loaded
	// safely (shortcode-bearing page or its footer), short-circuit to a
	// hard navigation. By this point the close icon has been clicked but
	// the close animation hasn't run yet — the browser unload will hide
	// the overlay naturally as the new page loads.
	if (directLoadHardNavCloseUrl) {
		window.location.href = directLoadHardNavCloseUrl
		return
	}

	// we saved the last history state of when we opened the overlay
	// and use it here to push to that history state

	// history_controller.pushState({ type: $this.attr('data-type'), id: $this.attr('data-id'), catid: catids }, title, href)
	if (historyStateOfOverviewPageWeCameFrom != null && historyStateOfOverviewPageWeCameFrom.href) {
		history_controller.pushState(
			{
				type: historyStateOfOverviewPageWeCameFrom.type,
				id: parseInt(historyStateOfOverviewPageWeCameFrom.id, 10),
				slug: historyStateOfOverviewPageWeCameFrom.slug,
				title: historyStateOfOverviewPageWeCameFrom.title,
				catid: historyStateOfOverviewPageWeCameFrom.catid,
			},
			historyStateOfOverviewPageWeCameFrom.title,
			historyStateOfOverviewPageWeCameFrom.href
		)
	} else if (window.history.length > 1) {
		// Defensive fallback: stored state is missing or has no href (would
		// otherwise throw `Invalid URL` in pushState's `new URL(href)`). The
		// browser back step lands on whatever the previous entry was, which
		// for a project-overlay close is essentially what we want.
		window.history.back()
	}
}

var bindCloseKey = function () {
	jQuery(document).on('click', '.close-projects-overlay', function () {
		if (isOverlayDisplayBlock()) {
			goBackToLastOverview()
		}
	})
}

var i = function () {
	if (window.utility_controller.isProjectsOverlayEnabled()) {
		bindEscapeKey()
		bindCloseKey()
		bindBackgroundClick()
	}
}

/**
 * Direct-load means: a visitor landed on a project URL via a hard load
 * (refresh, shared link, search engine), and PHP server-rendered the project
 * markup INSIDE `#lay-project-overlay` with `data-direct-load="1"` instead
 * of as a normal page in `body>.lay-content`.
 *
 * From the JS side the goal is to make this visit indistinguishable from
 * "user is on the underlay and clicked a project link" once the page is
 * interactive. The existing first-load pipeline (`bindOnContentReady` →
 * `transition_in('project_overlay')` → `doTransitionIn`) handles the heavy
 * lifting on its own: nav-sync session register/start, hide-stylesheet
 * cleanup, site-title fade, col stagger animation, final
 * `transition_navigation_in_completed`. We only do the bits that ARE genuinely
 * direct-load specific.
 */
var bootstrapDirectLoad = function (underlayInfo) {
	if (!window.utility_controller.isProjectsOverlayEnabled()) return false
	if (!underlayInfo) return false
	const overlay = document.getElementById('lay-project-overlay')
	if (!overlay || overlay.getAttribute('data-direct-load') !== '1') return false

	const projectStateObj = setupDirectLoadHistoryState(underlayInfo)
	applyDirectLoadOverlayEndState()
	emitDirectLoadLifecycleEvents(projectStateObj)
	return true
}

/**
 * Synthesize the history state that mirrors what `setShouldOpenAndShouldClose*`
 * would have populated on a SPA project-open. Two outputs:
 *   • `historyStateOfOverviewPageWeCameFrom` so the close button knows where
 *     to go back to (the configured underlay).
 *   • `replaceState` with the project's id/type/slug so any subsequent SPA
 *     navigation away from this page has a coherent `previousStateObj`.
 *
 * Side-effect: also sets `directLoadHardNavCloseUrl` when the underlay
 * contains shortcodes that prevent lazy-loading.
 */
function setupDirectLoadHistoryState(underlayInfo) {
	historyStateOfOverviewPageWeCameFrom = {
		href: underlayInfo.url || '/',
		type: underlayInfo.type || 'page',
		id: underlayInfo.id != null ? parseInt(underlayInfo.id, 10) : 0,
		slug: '',
		title: '',
		catid: '',
		// Tag so other code can detect the synthetic origin if needed.
		__direct_load_synthetic: true,
	}

	const projectType = document.body.getAttribute('data-type') || 'project'
	const projectId = document.body.getAttribute('data-id') || ''
	const projectSlug = document.body.getAttribute('data-slug') || ''
	const projectCatid = document.body.getAttribute('data-catid') || ''
	const projectStateObj = {
		type: projectType,
		id: projectId ? parseInt(projectId, 10) : 0,
		slug: projectSlug,
		title: document.title,
		catid: projectCatid,
	}
	previousStateObj = projectStateObj
	previousHref = window.location.href
	if (window.layHistory && typeof window.layHistory.replace === 'function') {
		window.layHistory.replace(window.location.pathname + window.location.search + window.location.hash, projectStateObj)
	} else if (window.history && typeof window.history.replaceState === 'function') {
		window.history.replaceState(projectStateObj, '', window.location.pathname + window.location.search + window.location.hash)
	}

	// Keep a hard-navigation fallback until the lazy underlay has actually
	// been injected. If the user closes a direct-loaded overlay before the
	// AJAX request finishes (or if it fails), destroying the overlay would
	// reveal only the empty PHP placeholder underneath.
	directLoadHardNavCloseUrl = underlayInfo.url || (window.location.protocol + '//' + window.location.host + '/')

	return projectStateObj
}

/**
 * Mirror the end-state that `animateIn` reaches in the SPA flow: the overlay
 * is "open", body is scroll-locked, html has the class other modules key off,
 * close icon exists, animateIn-finished flags are set, and any awaiter on
 * `hasAnimatedIn()` is resolved. Note the actual visible col-stagger / text
 * fade-in is NOT done here — that's `doTransitionIn`'s job, kicked off via
 * `bindOnContentReady`'s first-load `transition_in('project_overlay')` emit.
 */
function applyDirectLoadOverlayEndState() {
	addShowOverlayClass()
	utility_controller.fixBody()
	jQuery('html').addClass('project-overlay-transitioned-in')
	// Mirror the open-animation end-state for the background. SPA open
	// runs `anime({targets: '#lay-project-overlay-background', opacity:[0,1]})`
	// AND flips `display: none → block` in its `begin`. On direct-load
	// we skip the open animation entirely, so without this the bg stays
	// `display: none` (per base CSS). On close the bg's fade-out animation
	// then runs against an invisible element — user sees no backdrop.
	if (layData.po_background_behind_overlay == 'on') {
		const bg = document.getElementById('lay-project-overlay-background')
		if (bg) {
			bg.style.display = 'block'
			bg.style.opacity = '1'
		}
	}
	animateInFinished = true
	isAnimatingIn = false
	jQuery('body').addClass('lay-direct-load-active')
	insertCloseIcon()
	if (hasAnimatedInPromiseResolve) {
		hasAnimatedInPromiseResolve()
	}
}

/**
 * Same lifecycle emit-order as the SPA project-open path
 * (layout_controller.js:293-302). Listeners use these to set up scope-
 * specific state BEFORE `transition_in` and the subsequent timeline run:
 *   • smooth_scroll_controller → handleProjectOverlayShown / createOverlayLenis.
 *   • scrub.js → projectOverlayIntroPending = true (holds scrub pairings at 0
 *     until the intro fade fires).
 *   • textanimations.js → projectOverlayNavigationRevealPending = true and
 *     resets nav-synced overlay text-animations.
 */
function emitDirectLoadLifecycleEvents(projectStateObj) {
	if (!window.laytheme || typeof window.laytheme.emit !== 'function') return
	const $overlay = jQuery('#lay-project-overlay')
	window.laytheme.emit('project_overlay_before_animate_in')
	window.laytheme.emit('project_overlay_open_start', $overlay, projectStateObj)
	window.laytheme.emit('project_overlay_open_end', $overlay, projectStateObj)
}

/**
 * Setter used by direct_load.js after the underlay AJAX completes:
 * we want subsequent close clicks to use the SPA reveal (underlay is now in
 * the DOM and goBackToLastOverview's pushState will hide the overlay and
 * show the underlay).
 */
var clearDirectLoadHardNavMode = function () {
	directLoadHardNavCloseUrl = null
}

var insertCloseIcon = function () {
	if (window.utility_controller.isProjectsOverlayEnabled() && layData.po_show_close_icon == 'on') {
		if (jQuery('.close-projects-overlay').length > 0) return

		// `.close-projects-overlay` is part of the nav-anim UI fade
		// cascade (UI_FADE_SELECTOR in fadeIn_SiteTitle_MenuBar_Menu_etc.js).
		// The cascade adds the `lay-show-sitetitle-menubar-menu-etc`
		// stylesheet on `transition_in`, which flips `opacity: 0 → 1`
		// for every matching element — including our close icon — and
		// honours the per-element `transition-delay` the stagger flow
		// set so the icon joins the same wave as site title / menu /
		// burger.
		//
		// Auto-adding `po-fadein-close-icon` HERE would beat the
		// cascade: the class sets `opacity: 1` immediately, and by the
		// time `transition_in` fires the icon is already fully visible,
		// breaking the stagger. So we skip the auto-class and let the
		// cascade do the reveal.
		//
		// Fallback: if no nav-anim cascade ever fires (e.g. some
		// edge-case overlay path), we still add the class after a
		// short safety timeout so the icon doesn't stay invisible.
		var closeType = layData.po_close_type
		if (closeType !== 'default' && closeType !== 'text' && closeType !== 'custom') {
			closeType = layData.po_use_custom_close_icon == 'on' ? 'custom' : 'default'
		}
		if (closeType === 'custom' && !layData.po_custom_close_icon) {
			closeType = 'default'
		}

		var el = jQuery('<div class="close-projects-overlay"></div>')
		if (closeType === 'custom') {
			el.addClass('custom-close').append(jQuery('<img alt=""/>').attr('src', layData.po_custom_close_icon))
		} else if (closeType === 'text') {
			var textformat = layData.po_close_textformat || 'Default'
			var closeText = typeof layData.po_close_text === 'string' ? layData.po_close_text : 'close'
			el.addClass('text-close _' + textformat + '_no_spaces').text(closeText)
		} else {
			el.addClass('standard-close')
		}
		el.prependTo('body')
		if (layData.po_animation == 'none') {
			el.addClass('po-fadein-close-icon')
			return
		}
		// Reveal flow has TWO phases:
		// 1. During the nav-anim UI cascade: the icon's `transition-delay`
		//    is set by `fadeIn_SiteTitle_MenuBar_Menu_etc.js` and the
		//    cascade's show stylesheet flips `opacity: 0 → 1`. The icon
		//    staggers in alongside site title / menu / burger.
		// 2. After the cascade cleans up its show stylesheet (~at
		//    transition_in completion), the rule that set opacity to 1
		//    is GONE. Without an inline override the icon would snap
		//    back to the base CSS `opacity: 0` → visible "fade in, fade
		//    out" flicker the user reported.
		//
		// Fix: subscribe to `transition_navigation_in_completed` and
		// add the `po-fadein-close-icon` class then. The class is just
		// `opacity: 1` (no transition definition of its own), so it
		// LOCKS the already-visible icon in place. Adding it AFTER the
		// cascade also means the cascade's stagger isn't bypassed.
		var fallbackTimer = null
		var projectOverlayNavStarted = false
		var cleanupRevealListeners = function () {
			if (window.laytheme && typeof window.laytheme.off === 'function') {
				window.laytheme.off('transition_navigation_in_started', onNavStart)
				window.laytheme.off('transition_navigation_in_completed', onNavComplete)
			}
			if (fallbackTimer !== null) {
				clearTimeout(fallbackTimer)
				fallbackTimer = null
			}
		}
		var revealAndLockCloseIcon = function () {
			el.addClass('po-fadein-close-icon')
			// Dev-mode: the `po-fadein-close-icon` class is the SECOND
			// fade-in path for this button (the first is the UI cascade
			// in `fadeIn_SiteTitle_MenuBar_Menu_etc`). If both fire
			// during the same page load — i.e. the cascade collected
			// the button before this class was added so the skip check
			// at fadeIn_SiteTitle_MenuBar_Menu_etc.js:37 didn't match —
			// the button visually fades in twice. Use this event in
			// the dev-mode log to spot that case.
			if (typeof window.layDevModeEmit === 'function' && el && el[0]) {
				window.layDevModeEmit('close_icon:po_fadein_class_added', el[0])
			}
			cleanupRevealListeners()
		}
		var onNavStart = function (type) {
			if (type && type !== 'project_overlay') return
			projectOverlayNavStarted = true
		}
		var onNavComplete = function (type) {
			// Direct project-overlay loads can also trigger a normal underlay/page
			// navigation completion. That completion must not lock the overlay
			// close icon early, because the real project-overlay cascade may still
			// be pending and would then fade the already-visible icon a second time.
			if (type && type !== 'project_overlay') return
			revealAndLockCloseIcon()
		}
		if (window.laytheme && typeof window.laytheme.on === 'function') {
			window.laytheme.on('transition_navigation_in_started', onNavStart)
			window.laytheme.on('transition_navigation_in_completed', onNavComplete)
		}
		// Fallback safety: if no nav-anim cascade fires at all (e.g.
		// the overlay was inserted outside a transition_in flow, or the
		// emitter failed silently), the icon would never get revealed.
		// If a project-overlay nav cascade has already started, give that
		// cascade plenty of time to finish so the fallback does not lock the
		// icon mid-fade. If no cascade starts at all, reveal after 1500ms.
		fallbackTimer = setTimeout(function () {
			if (el.hasClass('po-fadein-close-icon')) return
			if (projectOverlayNavStarted) {
				fallbackTimer = setTimeout(function () {
					if (el.hasClass('po-fadein-close-icon')) return
					revealAndLockCloseIcon()
				}, 6000)
				return
			}
			revealAndLockCloseIcon()
		}, 1500)
	}
}

var removeCloseIcon = function () {
	jQuery('.close-projects-overlay').remove()
}

var isSameStateOfLastOverview = function (stateObj) {
	if (historyStateOfOverviewPageWeCameFrom != null) {
		if (historyStateOfOverviewPageWeCameFrom.type == stateObj.type && historyStateOfOverviewPageWeCameFrom.id == stateObj.id) {
			return true
		}
	}
	return false
}

var addShowOverlayClass = function () {
	// Scrollbar compensation is handled by scrollbar-gutter: stable in CSS
	jQuery('html').addClass('show-project-overlay')
}

// Single-owner state for the four anime instances driving the overlay's open
// / close transitions. Keeping the refs in one object (instead of four
// scattered `let`s) means cancellation always touches a consistent pair —
// the primary slide/fade + its companion background-layer animation — and
// no caller can forget one half. `cancelAnimation` uses anime's own
// `pause()` API; null/stale slots are safe to call.
var anims = { inPrimary: null, inSecondary: null, outPrimary: null, outSecondary: null }

function cancelAnimation(animation) {
	if (animation && typeof animation.pause === 'function') animation.pause()
}

function cancelOutboundAnims() {
	cancelAnimation(anims.outPrimary)
	cancelAnimation(anims.outSecondary)
	anims.outPrimary = null
	anims.outSecondary = null
}

function cancelInboundAnims() {
	cancelAnimation(anims.inPrimary)
	cancelAnimation(anims.inSecondary)
	anims.inPrimary = null
	anims.inSecondary = null
}

var isAnimatingIn = false
var animateInFinished = false
var animateIn = function (cb) {
	animateInFinished = false
	isAnimatingOut = false
	isAnimatingIn = true

	if (layData.po_animation == 'none') {
		addShowOverlayClass()
		utility_controller.fixBody()
		jQuery('html').addClass('project-overlay-transitioned-in')
		// Show background media immediately when animation is 'none'
		jQuery('#lay-project-overlay-background-media').attr('style', '')
		animateInFinished = true
		isAnimatingIn = false
		if (cb) {
			cb()
		}
	} else {
		cancelOutboundAnims()
		var animeObj = {
			targets: '#lay-project-overlay, #lay-project-overlay-background-media',
			loop: false,
			duration: duration,
			easing: cubicBezier,
			begin: function () {
				if (layData.po_background_behind_overlay == 'on') {
					// animate background in:
					anims.inSecondary = anime({
						targets: '#lay-project-overlay-background',
						loop: false,
						duration: duration,
						easing: cubicBezier,
						opacity: [0, 1],
						begin: function () {
							document.getElementById('lay-project-overlay-background').style.display = 'block'
						},
					})
				}

				addShowOverlayClass()
				utility_controller.fixBody()
				jQuery('html').addClass('project-overlay-transitioning')
			},
			complete: function () {
				animateInFinished = true
				isAnimatingIn = false
				if (hasAnimatedInPromiseResolve) {
					hasAnimatedInPromiseResolve()
				}
				jQuery('html').removeClass('project-overlay-transitioning')
				jQuery('html').addClass('project-overlay-transitioned-in')
				// remove transform, otherwise we cant have position fixed on the overlay, thus imagehover addon wouldnt work
				jQuery('#lay-project-overlay').attr('style', '')
				jQuery('#lay-project-overlay-background-media').attr('style', '')
				if (cb) {
					cb()
				}
			},
		}
		switch (layData.po_animation) {
			case 'fadein':
				animeObj['opacity'] = [0, 1]
				break
			case 'slideup':
				animeObj['translateY'] = ['100%', '0%']
				break
			case 'slidedown':
				animeObj['translateY'] = ['-100%', '0%']
				break
		}
		anims.inPrimary = anime(animeObj)
	}
}

var isAnimatingOut = false
var animateOutFinished = false
var emitProjectOverlayClosed = function () {
	var $overlay = jQuery('#lay-project-overlay')
	window.laytheme.emit('projectoverlayclosed')
	window.laytheme.emit('project_overlay_close_end', $overlay)
}
var animateOut = function (cb) {
	isAnimatingIn = false
	isAnimatingOut = true
	animateOutFinished = false
	window.laytheme.emit('project_overlay_close_start', jQuery('#lay-project-overlay'))
	if (layData.po_animation == 'none') {
		animateOutFinished = true
		isAnimatingOut = false
		jQuery('html').removeClass('project-overlay-transitioned-in')
		// Resolve promise if anyone is waiting (though this has the bug we documented)
		if (hasAnimatedOutPromiseResolve) {
			hasAnimatedOutPromiseResolve()
		}
		// Always emit event, regardless of callback
		// Remove background media container when overlay closes
		jQuery('#lay-project-overlay-background-media').remove()
		emitProjectOverlayClosed()
		if (cb) {
			cb()
		}
	} else {
		cancelInboundAnims()
		var primaryFinished = false
		var secondaryFinished = layData.po_background_behind_overlay != 'on'
		var closeFinalized = false
		var finalizeClose = function () {
			if (closeFinalized || !primaryFinished || !secondaryFinished) {
				return
			}
			closeFinalized = true
			isAnimatingOut = false
			animateOutFinished = true
			if (hasAnimatedOutPromiseResolve) {
				hasAnimatedOutPromiseResolve()
			}
			jQuery('html').removeClass('project-overlay-transitioning')
			jQuery('#lay-project-overlay-background-media').remove()
			emitProjectOverlayClosed()
			if (cb) {
				cb()
			}
		}

		var animeObj = {
			targets: '#lay-project-overlay, #lay-project-overlay-background-media',
			loop: false,
			duration: duration,
			easing: cubicBezier,
			begin: function () {
				jQuery('html').addClass('project-overlay-transitioning')
				jQuery('html').removeClass('project-overlay-transitioned-in')

				if (layData.po_background_behind_overlay == 'on') {
					// animate background in:
					anims.outSecondary = anime({
						targets: '#lay-project-overlay-background',
						loop: false,
						duration: duration,
						easing: cubicBezier,
						opacity: 0,
						complete: function () {
							var background = document.getElementById('lay-project-overlay-background')
							if (background) {
								background.style.display = 'none'
							}
							secondaryFinished = true
							finalizeClose()
						},
					})
				}
			},
			complete: function () {
				// :)
				document.getElementById('lay-project-overlay').scrollTop = 0

				primaryFinished = true
				finalizeClose()
			},
		}

		switch (layData.po_animation) {
			case 'fadein':
				animeObj['opacity'] = 0
				break
			case 'slideup':
				animeObj['translateY'] = '100%'
				break
			case 'slidedown':
				animeObj['translateY'] = '-100%'
				break
		}
		anims.outPrimary = anime(animeObj)
	}
}

// https://stackoverflow.com/questions/26150232/how-can-i-access-promise-resolution-callbacks-outside-the-promise-constructor-ca
// ⚠️ WARNING: These promises have a design flaw - they can only be used ONCE per animation!
// Each call to hasAnimatedIn() overwrites the previous resolve/reject callbacks.
// If multiple modules call this at the same time, only the last one will get notified.
// RECOMMENDED: Use the 'projectoverlayclosed' event instead for multiple listeners.
var hasAnimatedInPromiseResolve, hasAnimatedInPromiseReject
var hasAnimatedIn = function () {
	return new Promise(function (resolve, reject) {
		hasAnimatedInPromiseResolve = resolve
		hasAnimatedInPromiseReject = reject
		if (animateInFinished) {
			resolve()
		}
	})
}

// https://stackoverflow.com/questions/26150232/how-can-i-access-promise-resolution-callbacks-outside-the-promise-constructor-ca
// ⚠️ WARNING: These promises have a design flaw - they can only be used ONCE per animation!
// Each call to hasAnimatedOut() overwrites the previous resolve/reject callbacks.
// If multiple modules call this at the same time, only the last one will get notified.
// RECOMMENDED: Use the 'projectoverlayclosed' event instead for multiple listeners.
var hasAnimatedOutPromiseResolve, hasAnimatedOutPromiseReject
var hasAnimatedOut = function () {
	return new Promise(function (resolve, reject) {
		hasAnimatedOutPromiseResolve = resolve
		hasAnimatedOutPromiseReject = reject
		if (animateOutFinished) {
			resolve()
		}
	})
}

var addLoadingIndicator = function () {
	jQuery('#lay-project-overlay').addClass('po-content-loading')
}

var removeLoadingIndicator = function () {
	jQuery('#lay-project-overlay').removeClass('po-content-loading')
}

var mainPageHasFullscreenSlider = function () {
	var sliderSelector = '.vertical-fullpage, .horizontal-fullpage, .vertical-scrollsnap, .horizontal-scrollsnap'
	var $mainContent = jQuery('body > .lay-content')
	return $mainContent.filter(sliderSelector).add($mainContent.find(sliderSelector)).length > 0
}

var removeStaleFullscreenSliderNavIfNeeded = function () {
	if (mainPageHasFullscreenSlider()) {
		return
	}
	jQuery('#fp-nav, .fp-slidesNav').remove()
}

var destroyOverlay = function () {
	jQuery('html').removeClass('show-project-overlay')

	// Emit event BEFORE removing padding/compensation so scroll snap can destroy first
	window.laytheme.emit('destroyoverlay')

	// Scrollbar compensation is handled by scrollbar-gutter: stable in CSS

	jQuery('#lay-project-overlay')
		.html('')
		.removeAttr('style')
		.removeAttr('data-direct-load')
		.removeClass('is-open animation-none animation-slideup animation-slidedown animation-fadein po-content-loading horizontal-scroll-mode')
	jQuery('#lay-project-overlay-background').removeAttr('style')
	jQuery('body').removeClass('lay-direct-load-active')
	removeStaleFullscreenSliderNavIfNeeded()
	if (typeof requestAnimationFrame == 'function') {
		requestAnimationFrame(removeStaleFullscreenSliderNavIfNeeded)
	} else {
		setTimeout(removeStaleFullscreenSliderNavIfNeeded, 0)
	}
	utility_controller.unfixBody()
}

var projects_overlays = {
	addLoadingIndicator: function () {
		addLoadingIndicator()
	},
	removeLoadingIndicator: function () {
		removeLoadingIndicator()
	},
	setFirstState: function () {
		setFirstState()
	},
	i: function () {
		i()
	},
	setShouldOpenAndShouldCloseOnPush: function (stateObj) {
		setShouldOpenAndShouldCloseOnPush(stateObj)
	},
	setShouldOpenAndShouldCloseOnPop: function (stateObj) {
		setShouldOpenAndShouldCloseOnPop(stateObj)
	},
	shouldCloseOverlay: function () {
		return shouldCloseOverlay && isOverlayDisplayBlock()
	},
	shouldCloseOverlayAlt: function () {
		return shouldCloseOverlay
	},
	shouldOpenOverlay: function () {
		return shouldOpenOverlay
	},
	getOverviewPageId: function () {
		if (historyStateOfOverviewPageWeCameFrom && historyStateOfOverviewPageWeCameFrom.id != null) {
			return String(historyStateOfOverviewPageWeCameFrom.id)
		}
		return null
	},
	isOverlayDisplayBlock: function () {
		return isOverlayDisplayBlock()
	},
	insertCloseIcon: function () {
		insertCloseIcon()
	},
	isSameStateOfLastOverview: function (stateObj) {
		return isSameStateOfLastOverview(stateObj)
	},
	removeCloseIcon: function () {
		removeCloseIcon()
	},
	animateIn: function (cb) {
		animateIn(cb)
	},
	hasAnimatedIn: function () {
		return hasAnimatedIn()
	},
	hasAnimatedOut: function () {
		return hasAnimatedOut()
	},
	isAnimatingIn: function () {
		return isAnimatingIn
	},
	isAnimatingOut: function () {
		return isAnimatingOut
	},
	animateOut: function (cb) {
		animateOut(cb)
	},
	destroyOverlay: function () {
		destroyOverlay()
	},
	isSameStateOfLastOverview: function (stateObj) {
		return isSameStateOfLastOverview(stateObj)
	},
	bootstrapDirectLoad: function (underlayInfo) {
		return bootstrapDirectLoad(underlayInfo)
	},
	clearDirectLoadHardNavMode: function () {
		clearDirectLoadHardNavMode()
	},
	isDirectLoadHardNavMode: function () {
		return directLoadHardNavCloseUrl !== null
	},
}

// so i can access it from outside, for example in fullscreen slider addon
window.projects_overlays = projects_overlays

export default projects_overlays
